/* Created by: Upendram Reddy Tanuja
Created on: 06 - Aug - 2019 10: 30 PM
Purpose: class for  Profile Settings */

export class ProfileSettings {
    files: any;
    update_flag: number;
    user_id: string;
    //set default values when object is instatiated
    setData(obj = {
        files: '',
        update_flag: 1,
        user_id: 0,
    }) {
        this.files = obj.files || '';
        this.update_flag = 1;
        this.user_id = this.user_id || ''
    }
    //function to set the values entered in the formgroup into the object
    setFormGroupData(obj) {

        this.files = obj.files;
        this.update_flag = 1;
        this.user_id = obj.user_id;
    }
}